import { useEffect, useState } from "react";
import { getMidpointMediaInfrastructureStatus } from "../../api/partnerPortalApi";
import {
  badgeClass,
  formatStatusLabel,
} from "./midpointMediaCustomerPortalLabels";
import "../../styles/midpointMediaCustomerPortal.css";

export default function MidpointMediaCustomerInfrastructurePage() {
  const [infrastructure, setInfrastructure] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getMidpointMediaInfrastructureStatus()
      .then((body) => {
        if (!cancelled) setInfrastructure(body.infrastructure || null);
      })
      .catch((error) => {
        if (!cancelled) {
          setErrorMessage(error.message || "Unable to load infrastructure status.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="mm-customer-portal">
      <header className="mm-customer-portal__hero">
        <div>
          <p className="mm-customer-portal__eyebrow">Status</p>
          <h1>Infrastructure</h1>
          <p className="mm-customer-portal__intro">
            Platform API, database, and host status that Midpoint Media uses to
            run your Client Views.
          </p>
        </div>
        {infrastructure ? (
          <span className={badgeClass(infrastructure.overall)}>
            Overall: {formatStatusLabel(infrastructure.overall)}
          </span>
        ) : null}
      </header>

      {loading ? <p className="mm-customer-muted">Checking status…</p> : null}
      {errorMessage ? <p className="mm-customer-error">{errorMessage}</p> : null}

      {!loading && infrastructure ? (
        <section className="mm-customer-panel">
          <h3>Components</h3>
          {!infrastructure.live ? (
            <p className="mm-customer-muted">
              Showing the latest available signals. Some host metrics may be
              representative until live monitoring is connected.
            </p>
          ) : null}
          <div className="mm-customer-infra-grid">
            {(infrastructure.components || []).map((component) => (
              <article key={component.id} className="mm-customer-row">
                <div className="mm-customer-row__top">
                  <strong>{component.name}</strong>
                  <span className={badgeClass(component.status)}>
                    {formatStatusLabel(component.status)}
                  </span>
                </div>
                <p>{component.description}</p>
                {component.note ? <p>{component.note}</p> : null}
              </article>
            ))}
          </div>
        </section>
      ) : null}
    </div>
  );
}
